import React, { useEffect, useState } from 'react';
import styles from './styles.scoped.css';
import { Card } from '@mantine/core';
import Button from '../../components/elements/Button';
import IconArrowLeft from '../../components/icons/IconArrowLeft';
import TotpForm from '../../components/forms/TotpForm';
import { useDispatch, useSelector } from 'react-redux';
import { totpSend, totpReset, setCountTime } from './actions';
import { useNavigate, useLocation } from 'react-router-dom';
import { clearStorages, getTempToken, getUserData } from '../../utils/storage';
import { useTimer } from 'react-timer-hook';
import ModalExpiredToken from '../../components/fragments/ModalExpiredToken';

const Totp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMfaActive = getUserData()?.isMfaActive;
  const location = useLocation();

  const [modal, setModal] = useState(false);
  const { qrCountDown } = location.state || {};
  const { qrCountTime } = useSelector((s) => s.mfa);
  const { restart } = useTimer({
    expiryTimestamp: new Date(),
    onExpire: () => setModal(true),
    autoStart: false,
  });

  useEffect(() => {
    if (!getTempToken()) {
      clearStorages();
      navigate('/dc/login', { replace: true });
    }
    if (qrCountDown) {
      dispatch(setCountTime({ qrCountTime: qrCountDown }));
    }
  }, []);
  useEffect(() => {
    if (qrCountTime) {
      restart(qrCountTime);
    }
  }, [qrCountTime]);

  const handleBack = () => {
    if (isMfaActive) {
      clearStorages();
      navigate('/login', { replace: true });
    } else navigate(-1);
  };
  const handleRelog = () => {
    dispatch(totpReset());
  };

  return (
    <div className={styles.root}>
      <Card withBorder>
        <div>
          <Button onClick={handleBack} style="transparent">
            <IconArrowLeft />
            <span>Kembali</span>
          </Button>
        </div>
        <h4>Verifikasi Aplikasi Authenticator</h4>
        <TotpForm
          buttonSubmitLabel="Verifikasi"
          handleReset={() => dispatch(totpReset())}
          handleSubmit={(value) => dispatch(totpSend(value))}
          setModal={setModal}
        />
      </Card>
      <ModalExpiredToken handleRelog={handleRelog} opened={modal} />
    </div>
  );
};

export default Totp;
